/**
 * Project Formatter.
 * @param {*} value
 * @param {object} row
 * @returns {string}
 */
window.projectFormatter = function(value, row) {
    if (value === null) {
        return '';
    }
    let html = '';
    if (typeof row.project_active !== "undefined"
    && parseInt(row.project_active, 10) === 0) {
        html += '<span class="badge bg-secondary me-2">';
        html += __('INACTIVE');
        html += '</span>';
    }
    if (can('admin.projects.show') && row.project_id) {
        html += '<a href="/admin/projects/show/'+row.project_id+'">';
        html += value;
        html += '</a>';
    } else if (can('tuijncode.projects') && row.project_id) {
        html += '<a href="/tuijncode/projects/show/'+row.project_id+'">';
        html += value;
        html += '</a>';
    } else {
        html += value;
    }
    return html;
}
